import React, { useState, useEffect, useMemo } from 'react';
import { Grid, Typography, Box, IconButton } from "@material-ui/core";
import ButtonAtom from '../ButtonAtom/index.jsx'
import { makeStyles } from '@material-ui/styles';
import Avatar from '@mui/material/Avatar';
import ProductItem from '../ProductItem/index'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CallIcon from '@mui/icons-material/Call';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import GppGoodRoundedIcon from '@mui/icons-material/GppGoodRounded';
import firebase from "../../config/firebase/index";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { fontSize, fontWeight } from '@mui/system';
import Drawer from '@material-ui/core/Drawer';
import MobileBrowserMarketDrawer from '../../pages/Mobile_Browser_Market1/Mobile_Browser_Market1';
import ReactGA from "react-ga";
import encSecret from '../../config/encryption/index.js';
import VisibilitySensor from 'react-visibility-sensor';
import { Button } from '@mui/material';
import Suggest_Bid from '../../pages/Suggest_Bid/Suggest_Bid.js';
var CryptoJS = require("crypto-js");
var viewDeals = [];

const SuggestTable = (props) => {

    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {
        console.log("Inside SUGGESTIONS :::::")
        firebase.database().ref("Customer").orderByChild("DealId")
            .equalTo(props.id).on("value", snapshot => {
                console.log(":::: Suggestions :::", snapshot.val());
                let dealsData = snapshot.val();
                let customerArr = [];
                for (const key in dealsData) {
                    if (dealsData[key].method === "suggest") {
                        const dealObj = {
                            id: key,
                            ...dealsData[key],
                        };
                        // NoOfViews(dealObj);
                        console.log("::: ::: :::: ", dealObj)
                        customerArr.push(dealObj);
                    }

                }
                console.log("CA ::::", customerArr);
                setSuggestions(customerArr);
            });
    }, []);


    return (

        <Box>{
            suggestions && suggestions.length ?
                <div style={{ display: "flex", justifyContent: "space-between", background: "#f2f2f2", fontSize: 14 }}>

                    <div style={{ width: "94%", textAlign: "center", padding: 10 }}>
                        <div style={{ fontWeight: "bold", textAlign: "center", width: "100%" }}>खरीदार</div>
                        <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "20% 40% 40%" }}>
                            <div style={{ padding: "5px 0px" }}>नाम</div>
                            <div style={{ padding: "5px 0px" }}>मात्रा</div>
                            <div style={{ padding: "5px 0px" }}>बोली</div>

                        </div>

                        {
                            suggestions && suggestions.length && suggestions.sort((a, b) => parseInt(a.price) < parseInt(b.price) ? 1 : -1).map((suggestion, index) => (
                                <div key={index} style={{ display: "grid", gridTemplateColumns: "20% 40% 40%" }}>

                                    {
                                        suggestion.dealSuggestType == "buy" ? <>
                                            <div style={{ padding: "5px 0px" }}>{suggestion.Name ? CryptoJS.AES.decrypt(suggestion.Name, encSecret.key).toString(CryptoJS.enc.Utf8).substring(0, 1) + "xx" : "-"}</div>
                                            <div style={{ padding: "5px 0px" }}>{suggestion.quantity ? suggestion.quantity : "-"}</div>
                                            <div style={{ padding: "5px 0px" }}>Rs.{suggestion.price ? suggestion.price : "-"}</div>
                                        </>
                                            :
                                            <></>
                                    }
                                </div>
                            ))
                        }
                    </div>

                    <div style={{ width: "94%", textAlign: "center", padding: 10 }}>
                        <div style={{ fontWeight: "bold", textAlign: "center", width: "100%" }}>विक्रेता</div>
                        <div style={{ display: "grid", fontWeight: "bold", gridTemplateColumns: "20% 40% 40%" }}>
                            <div style={{ padding: "5px 0px" }}>नाम</div>
                            <div style={{ padding: "5px 0px" }}>मात्रा</div>
                            <div style={{ padding: "5px 0px" }}>बोली</div>

                        </div>

                        {
                            suggestions && suggestions.length && suggestions.sort((a, b) => parseInt(a.price) > parseInt(b.price) ? 1 : -1).map((suggestion, index) => (

                                <div  key={index} style={{ display: "grid", gridTemplateColumns: "20% 40% 40%" }}>
                                    {
                                        suggestion.dealSuggestType == "sale" ? <>
                                            <div style={{ padding: "5px 0px" }}>{suggestion.Name ? CryptoJS.AES.decrypt(suggestion.Name, encSecret.key).toString(CryptoJS.enc.Utf8).substring(0, 1) + "xx" : "-"}</div>
                                            <div style={{ padding: "5px 0px" }}>{suggestion.quantity ? suggestion.quantity : "-"}</div>
                                            <div style={{ padding: "5px 0px" }}>Rs.{suggestion.price ? suggestion.price : "-"}</div>

                                        </>
                                            : <></>
                                    }
                                </div>


                            ))


                        }


                    </div>

                </div>

                : <></>
        }

        </Box>
    );
}

const useStyles = makeStyles(() => ({
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 20,
            borderRadius: '20px 20px 0 0',
        }
    },
    headerBrowser: {
        background: '#53252f',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    kishanDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    textCenterSet: {
        display: 'flex',
        alignItems: 'center',
    },
    rotateSHareIcon: {
        transform: 'rotateY(360deg)',
    },
    contetnArrange: {
        width: '100%',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& div': {
            width: '100%'
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto'
    },
    manageIconCenter: {
        justifyContent: 'center',
        padding: '50px 0 20px',
        boxSizing: 'border-box',
    },
    image: {
        width: '35px',
        height: '35px',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'hidden',
    },
    footerFixed: {
        position: 'fixed',
    },

    dealerCall: {
        width: '55%',
        padding: '10px 20px',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '200px',
        marginLeft: '60px',
    },
}))

export default SuggestTable;
